import React from "react";
import NotFoundDateImage from '../../../assest/images/Empty-Illustration.png';
import './NotFoundDataInDate.scss';
import NotFoundDataIState , {NotFoundDataIProps} from './NotFoundDataInDate.models'

export default class NotFoundDataInDate extends React.PureComponent<NotFoundDataIProps, NotFoundDataIState> {

    render(): React.ReactNode {
        let title, image, width, height, subTitleClass;

        subTitleClass = this.props.config?.subTitleClass ?? "subtitle"
        width = this.props.config?.width ?? "160"
        height = this.props.config?.height ?? "145"
        image = this.props.image ?? NotFoundDateImage
        title = this.props.title ?? "می توانید بازه‌ی زمانی دیگری را انتخاب کنید"
    
        if (this.props.title !== null && this.props.title !== undefined) {
            title = this.props.title;
        }
        else title = "می توانید بازه‌ی زمانی دیگری را انتخاب کنید";

        return (<>
            <div className="not-found-data-area">
                <div className="col-12" >
                    <img src={image} width={width} height={height} alt="not found data in date range" />
                </div>
                <div className="col-12">
                    <label className={subTitleClass}>
                        <label>{title}</label>
                    </label>
                </div>
            </div>
        </>);
    }
}